import React, { ReactElement } from 'react'
import { TextArea, TextAreaProps } from '../../../../React/Common/Components/TextArea/TextArea'

export const OutlineTextAreaMulti = (props: TextAreaProps): ReactElement => (
    <TextArea {...props} additionalClassNames='outlined-text-area' />
)
